import type { GlobalSearchApiResponse } from '../interfaces/global-search.interface'
import { agentsApiSlice } from './agents-api.store'

const globalSearchEndpoints = agentsApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    globalSearch: builder.query<GlobalSearchApiResponse, string>({
      query: (q) => ({
        url: '/api/v1/search',
        params: { q },
      }),
    }),
  }),
})

export const { useGlobalSearchQuery } = globalSearchEndpoints
